import PubSub from 'pubsub-js';

PubSub.subscribe('init', () => {
    $('.header__language').each((index, element) => {
        $(element).on('click', async () => {
            const localize = $(element).data('localize');
            const postData = {
                localize,
                action: 'localize',
              };
    
              try {
                const responseLocalize = await $.ajax({
                    type: 'post',
                    url: ajaxUrl,
                    data: postData,
                });
                const response = JSON.parse(responseLocalize);
                if (response.success) {
                    window.location.reload();
                }
              } catch (error) {
                console.log(error);
              }
    
        });
    });
});